import DrawerImageHeader from './DrawerImageHeader';

export default DrawerImageHeader;
